export default "__VITE_ASSET__TZSLRS0z__"